import { render, staticRenderFns } from "./AddTriageAnswer.vue?vue&type=template&id=2ccf7e44&scoped=true&"
import script from "./AddTriageAnswer.vue?vue&type=script&lang=js&"
export * from "./AddTriageAnswer.vue?vue&type=script&lang=js&"
import style0 from "./AddTriageAnswer.vue?vue&type=style&index=0&id=2ccf7e44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccf7e44",
  null
  
)

export default component.exports